<template>
  <div class="d-flex" :class="[alignItems]">
    <span class="font-weight-bold mr-5px">{{ title }}:</span> {{ value || '-' }}
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: false
    },
    alignItems: {
      type: String,
      default: 'align-items-center'
    }
  }
};
</script>
